module.exports = __webpack_public_path__ + "img/traffic-light.1de9810d.png";